export function nullOrWhitespace(str) {
  return !str || (typeof str === 'string' && str.trim().length == 0);
}
